import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined,
    // refresh çağrısı son sayfayı koruyabilsin diye saklanır
    page: {},
    record: null,
    recordLoading: false
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit}, {page, filterData}) {
        commit('setLoading', true)

        state.filterData = filterData;
        state.page = page ?? {};

        let params = {
            page: page.current,
            page_limit: page.pageSize
        };

        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoint.get('cdn_server', 'developer'), {
            params: params
        })

        const {data, meta} = res.data
        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    // refresh records
    refresh({state, dispatch}) {
        return dispatch('get', {page: state.page ?? {}, filterData: state.filterData})
    },

    // get single record
    async show({commit}, {id}) {
        commit('setRecordLoading', true)

        try {
            const res = await this._vm.axios.get(this._vm.endpoint.get('cdn_server', 'developer') + '/' + id)

            commit('setRecord', res.data.data)

            return res.data.data
        } finally {
            commit('setRecordLoading', false)
        }
    },
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    setRecord(state, record) {
        state.record = record
    },
    setRecordLoading(state, val) {
        state.recordLoading = val
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
